import { render, staticRenderFns } from "./physiology.vue?vue&type=template&id=cabe4bd4&scoped=true&"
import script from "./physiology.vue?vue&type=script&lang=js&"
export * from "./physiology.vue?vue&type=script&lang=js&"
import style0 from "./physiology.vue?vue&type=style&index=0&id=cabe4bd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cabe4bd4",
  null
  
)

export default component.exports